__turbopack_context__.v({
  "link": "IconCategoryBrowse-module-scss-module__wUQpfG__link",
  "root": "IconCategoryBrowse-module-scss-module__wUQpfG__root",
});
